export const SET_OTHER_RESPONSES = "SET_OTHER_RESPONSES";
export const SET_CONFIG = "SET_CONFIG";
export const POST_BODY = {
  user: [],
  session: [],
  event: [],
};
